import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const GymIcon24 = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill='none'
    {...props}
  >
    <Path
      d='M8.75 5.25H6.5C6.08579 5.25 5.75 5.58579 5.75 6V18C5.75 18.4142 6.08579 18.75 6.5 18.75H8.75C9.16421 18.75 9.5 18.4142 9.5 18V6C9.5 5.58579 9.16421 5.25 8.75 5.25Z'
      stroke='#3379BD'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M18.5 5.25H16.25C15.8358 5.25 15.5 5.58579 15.5 6V18C15.5 18.4142 15.8358 18.75 16.25 18.75H18.5C18.9142 18.75 19.25 18.4142 19.25 18V6C19.25 5.58579 18.9142 5.25 18.5 5.25Z'
      stroke='#3379BD'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round' />
    <Path
      d='M19.25 7.5H21.5C21.6989 7.5 21.8897 7.57902 22.0303 7.71967C22.171 7.86032 22.25 8.05109 22.25 8.25V15.75C22.25 15.9489 22.171 16.1397 22.0303 16.2803C21.8897 16.421 21.6989 16.5 21.5 16.5H19.25'
      stroke='#3379BD'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M5.75 16.5H3.5C3.30109 16.5 3.11032 16.421 2.96967 16.2803C2.82902 16.1397 2.75 15.9489 2.75 15.75V8.25C2.75 8.05109 2.82902 7.86032 2.96967 7.71967C3.11032 7.57902 3.30109 7.5 3.5 7.5H5.75' stroke='#3379BD' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    <Path
      d='M9.5 12H15.5'
      stroke='#3379BD'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M22.25 12H23.75'
      stroke='#3379BD'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round' />
    <Path
      d='M1.25 12H2.75'
      stroke='#3379BD'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </Svg>
);

export default GymIcon24;
